export type AsyncAvData = {
  request_uuid: string;
  ageVerificationMethodCode: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  email: string;
  sessionUrl: string;
  workflowName?: string;
  workflowDefinitionId?: string;
};

type SessionAuthData = {
  saveAsyncAvData: (asyncAvData: AsyncAvData) => void;
  getAsyncAvData: () => AsyncAvData | null;
  clearAsyncAvData: () => void;
};

const SESSION_ASYNC_AV_DATA = "SESSION_ASYNC_AV_DATA";

export const useSessionAsyncAv = (): SessionAuthData => {
  const saveAsyncAvData = (asyncAvData: AsyncAvData) => {
    sessionStorage.setItem(SESSION_ASYNC_AV_DATA, JSON.stringify(asyncAvData));
  };
  const getAsyncAvData = (): AsyncAvData | null => {
    const data = sessionStorage.getItem(SESSION_ASYNC_AV_DATA);
    if (data) {
      try {
        return JSON.parse(data) as AsyncAvData;
      } catch (error) {
        console.error("Cannot parse SESSION_ASYNC_AV_DATA", error);
      }
    }
    return null;
  };
  const clearAsyncAvData = () => {
    sessionStorage.removeItem(SESSION_ASYNC_AV_DATA);
  };
  return {
    saveAsyncAvData,
    getAsyncAvData,
    clearAsyncAvData,
  };
};
